<template>
  <div>
    <img :src="require('@/assets/layout/icon'+id+ (checkThis == id ? '' : '-1')+'.png')" alt="" class="icon">
  </div>
</template>
<script>
export default{
  props:{
    checkThis:'',
    id:''
  },
  
}
</script>
<style scoped>
.icon{
  width: 18px;
  height: 18px;
  margin-right: 6px;
  display: block;
}
</style>